module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Bold.woff2
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Bold.woff2
// module chunks = styles